(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire46a9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire46a9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jU1Wv", function(module, exports) {

var $l8I3q = parcelRequire("l8I3q");
const $9cf00ee2bbca7138$var$handleButtonClick = (button)=>{
    const originalText = button.textContent;
    const buttonObserver = new MutationObserver(()=>{
        if (button.textContent !== originalText) {
            buttonObserver.disconnect();
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer?.renderContents) {
                (0, $l8I3q.updateElements)([
                    ".drawer__inner",
                    ".cart-count-bubble"
                ]);
                cartDrawer.renderContents();
                cartDrawer.classList.remove("is-empty");
            }
        }
    });
    buttonObserver.observe(button, {
        attributes: true
    });
};
const $9cf00ee2bbca7138$var$findAndHandleButtons = ()=>{
    const buttons = document.querySelectorAll(".swym-add-to-cart-btn");
    if (buttons.length > 0) {
        buttons.forEach((button)=>{
            button.addEventListener("click", ()=>$9cf00ee2bbca7138$var$handleButtonClick(button));
        });
        return true;
    }
    return false;
};
const $9cf00ee2bbca7138$var$handleWishlistAddToCart = ()=>{
    const mainObserver = new MutationObserver((mutations, observer)=>{
        const hasFoundButtons = $9cf00ee2bbca7138$var$findAndHandleButtons();
        if (hasFoundButtons) observer.disconnect();
    });
    mainObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
};
$9cf00ee2bbca7138$var$handleWishlistAddToCart();

});
parcelRegister("l8I3q", function(module, exports) {

$parcel$export(module.exports, "updateElements", () => $07d5380be57d91f1$export$c5303087167e431c);
const $07d5380be57d91f1$export$c5303087167e431c = async (selectors, sectionId)=>{
    try {
        const response = await fetch(sectionId ? `?sections=${sectionId}` : location.href);
        const html = sectionId ? (await response.json())[sectionId] : await response.text();
        const newdoc = new DOMParser().parseFromString(html, "text/html");
        if (typeof selectors === "string") selectors = [
            selectors
        ];
        for (const selector of selectors){
            const elements = document.querySelectorAll(selector);
            const newElements = newdoc.querySelectorAll(selector);
            if (elements.length !== newElements.length) throw new Error("Elements count mismatch for: " + selector);
            elements.forEach((element, index)=>{
                const newElement = newElements[index];
                if (element && newElement) element.outerHTML = newElement.outerHTML;
            });
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error({
            error: error
        });
    }
};

});


parcelRegister("e0FTq", function(module, exports) {
document.addEventListener("click", (event)=>{
    if (event.target instanceof HTMLElement) {
        const isPaginationItem = event.target.closest(".pagination__item");
        if (isPaginationItem) {
            const productGridContainer = document.querySelector(".product-grid-container");
            if (productGridContainer) {
                const header = document.querySelector("header");
                const headerHeight = header ? header.offsetHeight : 0;
                const elementPosition = productGridContainer.getBoundingClientRect().top + window.pageYOffset - headerHeight - 40;
                window.scrollTo({
                    top: elementPosition,
                    behavior: "smooth"
                });
            } else window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }
});

});

parcelRegister("6R7pS", function(module, exports) {
function $5e9671ce07f3b44c$var$initRepairNetwork(componentNode) {
    if (!(componentNode instanceof HTMLElement)) return;
    if (componentNode.dataset.repairNetworkBound === "true") return;
    componentNode.dataset.repairNetworkBound = "true";
    const repairSelect = componentNode.querySelector("[data-repair-network-select]");
    if (!(repairSelect instanceof HTMLSelectElement)) return;
    const cardNodes = Array.from(componentNode.querySelectorAll("[data-repair-network-item]"));
    const repairCards = cardNodes.filter((node)=>node instanceof HTMLElement).map((element)=>({
            element: element,
            key: element.dataset.key ?? ""
        }));
    const showSelectedByKey = (selectedKey)=>{
        repairCards.forEach(({ element: element, key: key })=>{
            if (key === selectedKey) element.removeAttribute("hidden");
            else element.setAttribute("hidden", "hidden");
        });
    };
    repairSelect.addEventListener("change", ()=>showSelectedByKey(repairSelect.value));
    showSelectedByKey(repairSelect.value);
}
function $5e9671ce07f3b44c$var$mountRepairNetworksIn(rootNode) {
    Array.from(rootNode.querySelectorAll("[data-repair-network]")).forEach($5e9671ce07f3b44c$var$initRepairNetwork);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>$5e9671ce07f3b44c$var$mountRepairNetworksIn(document));
else $5e9671ce07f3b44c$var$mountRepairNetworksIn(document);
document.addEventListener("shopify:section:load", (event)=>{
    const targetNode = event.target;
    if (targetNode instanceof HTMLElement) $5e9671ce07f3b44c$var$mountRepairNetworksIn(targetNode);
});

});

parcelRequire("jU1Wv");
parcelRequire("e0FTq");
parcelRequire("6R7pS");
const $cd2df92b128184fc$var$TOGGLE_SELECTOR = ".category-slider__description-toggle";
const $cd2df92b128184fc$var$COLLAPSIBLE_CLASS = "is-collapsible";
const $cd2df92b128184fc$var$OPEN_CLASS = "is-open";
const $cd2df92b128184fc$var$btn = document.querySelector($cd2df92b128184fc$var$TOGGLE_SELECTOR);
if ($cd2df92b128184fc$var$btn instanceof HTMLButtonElement) {
    $cd2df92b128184fc$var$btn.classList.add("is-ready");
    const id = $cd2df92b128184fc$var$btn.getAttribute("aria-controls");
    const wrap = id ? document.getElementById(id) : null;
    if (wrap) {
        wrap.classList.add($cd2df92b128184fc$var$COLLAPSIBLE_CLASS);
        const expanded = $cd2df92b128184fc$var$btn.getAttribute("aria-expanded") === "true";
        wrap.setAttribute("aria-hidden", String(!expanded));
        if (expanded) {
            wrap.classList.add($cd2df92b128184fc$var$OPEN_CLASS);
            wrap.style.maxHeight = `${wrap.scrollHeight}px`;
        }
        $cd2df92b128184fc$var$btn.addEventListener("click", ()=>{
            const isExpanded = $cd2df92b128184fc$var$btn.getAttribute("aria-expanded") === "true";
            if (!isExpanded) {
                $cd2df92b128184fc$var$btn.setAttribute("aria-expanded", "true");
                wrap.classList.add($cd2df92b128184fc$var$OPEN_CLASS);
                wrap.setAttribute("aria-hidden", "false");
                requestAnimationFrame(()=>{
                    wrap.style.maxHeight = `${wrap.scrollHeight}px`;
                });
            } else {
                $cd2df92b128184fc$var$btn.setAttribute("aria-expanded", "false");
                wrap.style.maxHeight = `${wrap.scrollHeight}px`;
                requestAnimationFrame(()=>{
                    wrap.classList.remove($cd2df92b128184fc$var$OPEN_CLASS);
                    wrap.setAttribute("aria-hidden", "true");
                    wrap.style.maxHeight = "";
                });
            }
            const labelMore = $cd2df92b128184fc$var$btn.dataset.labelMore;
            const labelLess = $cd2df92b128184fc$var$btn.dataset.labelLess;
            const span = $cd2df92b128184fc$var$btn.querySelector("span");
            if (span && labelMore && labelLess) span.textContent = isExpanded ? labelMore : labelLess;
        });
    }
}


const $5fe3604b02912324$var$BADGES_SELECTOR = '[data-entity="ss-badges"]';
const $5fe3604b02912324$var$PERCENTAGE_OFF_TAG = "percentage-off-sale";
const $5fe3604b02912324$var$SPECIAL_ORDER_TAG = "special-order";
const $5fe3604b02912324$var$FETCH_TIMEOUT_MS = 8000;
const $5fe3604b02912324$var$UNKNOWN_LOCATION_RANK = 10;
const $5fe3604b02912324$var$DEFAULT_PRIORITY = 100;
let $5fe3604b02912324$var$cachedTagsConfig;
function $5fe3604b02912324$var$fetchJson(url) {
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>controller.abort(), $5fe3604b02912324$var$FETCH_TIMEOUT_MS);
    return fetch(url, {
        credentials: "omit",
        signal: controller.signal
    }).then((response)=>response.ok ? response.json() : null).catch(()=>null).finally(()=>clearTimeout(timeoutId));
}
async function $5fe3604b02912324$var$fetchBadges(siteId, sku) {
    const url = "https://api.searchspring.net/api/search/search.json?siteId=" + encodeURIComponent(siteId) + "&resultsFormat=native&resultsPerPage=10&q=" + encodeURIComponent(sku);
    const data = await $5fe3604b02912324$var$fetchJson(url);
    const results = data?.results;
    if (!results || !results.length) return [];
    const exactMatch = results.find((result)=>result.sku === sku);
    const source = exactMatch ?? results[0];
    return source.badges && Array.isArray(source.badges) ? source.badges : [];
}
async function $5fe3604b02912324$var$fetchTagsConfig(siteId) {
    if ($5fe3604b02912324$var$cachedTagsConfig !== undefined) return $5fe3604b02912324$var$cachedTagsConfig;
    const url = "https://" + encodeURIComponent(siteId) + ".a.searchspring.io/api/meta/meta?siteId=" + encodeURIComponent(siteId);
    const data = await $5fe3604b02912324$var$fetchJson(url);
    $5fe3604b02912324$var$cachedTagsConfig = data?.badges && typeof data.badges.tags === "object" ? data.badges.tags ?? null : null;
    return $5fe3604b02912324$var$cachedTagsConfig;
}
function $5fe3604b02912324$var$getLocationRank(location) {
    if (location === "callout") return 0;
    if (location === "left") return 1;
    if (location === "right") return 2;
    return $5fe3604b02912324$var$UNKNOWN_LOCATION_RANK;
}
function $5fe3604b02912324$var$renderBadges(containerElement, badges, tagsConfig) {
    const hasPercentageOff = badges.some((badge)=>badge?.tag === $5fe3604b02912324$var$PERCENTAGE_OFF_TAG);
    const badgesWithIndex = badges.map((badge, index)=>({
            badge: badge,
            index: index
        }));
    const filteredBadges = badgesWithIndex.filter(({ badge: badge })=>{
        const tag = badge.tag || "";
        const value = badge.value || "";
        if (!tag && !value) return false;
        if (tag === "sale" && hasPercentageOff) return false;
        if (tag === $5fe3604b02912324$var$SPECIAL_ORDER_TAG) return false;
        if (value.toLowerCase().includes("special order")) return false;
        if (!tagsConfig || !tag) return true;
        const config = tagsConfig[tag];
        if (config && config.enabled === false) return false;
        return true;
    });
    if (!filteredBadges.length) return;
    if (tagsConfig) filteredBadges.sort((left, right)=>{
        const leftTag = left.badge.tag || "";
        const rightTag = right.badge.tag || "";
        const leftConfig = leftTag ? tagsConfig[leftTag] : undefined;
        const rightConfig = rightTag ? tagsConfig[rightTag] : undefined;
        const leftLocationRank = $5fe3604b02912324$var$getLocationRank(leftConfig?.location && leftConfig.location.split("/")[0]);
        const rightLocationRank = $5fe3604b02912324$var$getLocationRank(rightConfig?.location && rightConfig.location.split("/")[0]);
        if (leftLocationRank !== rightLocationRank) return leftLocationRank - rightLocationRank;
        const leftPriority = typeof leftConfig?.priority === "number" ? leftConfig.priority : $5fe3604b02912324$var$DEFAULT_PRIORITY;
        const rightPriority = typeof rightConfig?.priority === "number" ? rightConfig.priority : $5fe3604b02912324$var$DEFAULT_PRIORITY;
        if (leftPriority !== rightPriority) return leftPriority - rightPriority;
        return left.index - right.index;
    });
    const fragment = document.createDocumentFragment();
    for (const { badge: badge } of filteredBadges){
        const tag = badge.tag || "";
        const value = badge.value || "";
        const badgeWrapper = document.createElement("div");
        const wrapperClasses = [
            "card__badge",
            "top"
        ];
        if (tagsConfig && tag) {
            const config = tagsConfig[tag];
            const location = config?.location;
            if (location) {
                const locationKey = location.split("/")[0];
                if (locationKey === "right") wrapperClasses.push("right");
            }
        }
        badgeWrapper.className = wrapperClasses.join(" ");
        const badgeLabel = document.createElement("span");
        badgeLabel.className = tagsConfig ? "ss-pdp-badge" : "ss-pdp-badge-default";
        const parameters = tagsConfig?.[tag]?.parameters;
        if (parameters?.colorText) badgeLabel.style.color = parameters.colorText;
        if (parameters?.color) badgeLabel.style.backgroundColor = parameters.color;
        const imageUrl = parameters?.url;
        if (imageUrl) {
            const image = document.createElement("img");
            image.className = "ss-pdp-badge-img";
            image.src = imageUrl;
            image.alt = value || tag;
            badgeLabel.textContent = "";
            badgeLabel.append(image);
        } else badgeLabel.textContent = tag === $5fe3604b02912324$var$PERCENTAGE_OFF_TAG && value ? `${value}` : value || tag;
        badgeWrapper.append(badgeLabel);
        fragment.append(badgeWrapper);
    }
    containerElement.classList.add("card__badges");
    if (!tagsConfig) containerElement.classList.add("badges", "badges--top-left");
    containerElement.append(fragment);
}
async function $5fe3604b02912324$var$mountBadges(containerElement) {
    if (containerElement.dataset.ssBadgesBound === "true" || containerElement.childElementCount) return;
    const { id: sku, siteId: siteId } = containerElement.dataset;
    if (!sku || !siteId) return;
    containerElement.dataset.ssBadgesBound = "true";
    const [badges, tagsConfig] = await Promise.all([
        $5fe3604b02912324$var$fetchBadges(siteId, sku),
        $5fe3604b02912324$var$fetchTagsConfig(siteId)
    ]);
    if (badges.length) $5fe3604b02912324$var$renderBadges(containerElement, badges, tagsConfig);
}
function $5fe3604b02912324$var$mountBadgesIn(rootNode) {
    rootNode.querySelectorAll($5fe3604b02912324$var$BADGES_SELECTOR).forEach((element)=>{
        if (element instanceof HTMLElement) $5fe3604b02912324$var$mountBadges(element);
    });
}
if (document.readyState !== "loading") $5fe3604b02912324$var$mountBadgesIn(document);
document.addEventListener("DOMContentLoaded", ()=>$5fe3604b02912324$var$mountBadgesIn(document));
document.addEventListener("shopify:section:load", (event)=>{
    const targetElement = event.target;
    if (targetElement instanceof HTMLElement) $5fe3604b02912324$var$mountBadgesIn(targetElement);
});



})();
//# sourceMappingURL=global.js.map
